(() => {
  'use strict';
  const points = {
    home: [[37.5,47.6],[65,42.4],[51.8,59],[51.4,24.8],[69.4,63.7],[24.4,18.5]],
    business: [[40.8,64.2],[39.3,44.7],[67.4,38.4],[87,31.3],[67.6,58.5],[25.3,17.1]]
  };
  function initialize(root) {
    if (root.dataset.msReady) return;
    const configNode = root.querySelector('[data-ms-config]');
    if (!configNode) return;
    const config = JSON.parse(configNode.textContent);
    root.dataset.msReady = 'true';
    let property = 'home';
    const selected = {home:new Set(config.defaults), business:new Set(config.defaults)};
    const form = root.querySelector('.ms-quote-form');
    const propertyField = root.querySelector('[data-ms-property-field]');
    const dialog = root.querySelector('[data-ms-dialog]');
    const feedback = root.querySelector('[data-ms-feedback]');
    const number = i => String(i + 1).padStart(2, '0');
    function update() {
      const labels = config[property];
      const chosen = selected[property];
      const names = labels.map((label, i) => chosen.has(i) ? number(i) + ' — ' + label : null).filter(Boolean);
      root.querySelectorAll('[data-ms-property]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.msProperty === property)));
      root.querySelectorAll('[data-ms-area]').forEach(button => {
        const i = Number(button.dataset.msArea);
        button.setAttribute('aria-pressed', String(chosen.has(i)));
        button.setAttribute('aria-label', number(i) + ': ' + labels[i]);
        button.querySelector('[data-ms-area-label]').textContent = labels[i];
      });
      root.querySelectorAll('[data-ms-map-area]').forEach(button => {
        const i = Number(button.dataset.msMapArea);
        button.setAttribute('aria-pressed', String(chosen.has(i)));
        button.setAttribute('aria-label', number(i) + ': ' + labels[i]);
        button.title = number(i) + ': ' + labels[i];
        button.querySelector('i').textContent = labels[i];
        button.style.left = points[property][i][0] + '%';
        button.style.top = points[property][i][1] + '%';
      });
      root.querySelectorAll('[data-ms-route]').forEach(path => {
        const i = Number(path.dataset.msRoute);
        const [x, y] = points[property][i];
        const endX = Math.round(x * 7.2), endY = Math.round(y * 6.2);
        path.setAttribute('d', 'M500 395L500 ' + endY + 'L' + endX + ' ' + endY);
        path.classList.toggle('ms-route-active', chosen.has(i));
      });
      root.querySelector('[data-ms-map]').dataset.msMap = property;
      root.querySelector('[data-ms-kind]').textContent = property === 'home' ? 'HOME' : 'BUSINESS';
      root.querySelector('[data-ms-plan-count]').textContent = chosen.size + ' ' + (chosen.size === 1 ? config.one : config.unit) + ' selected';
      root.querySelector('[data-ms-map-count]').textContent = chosen.size + ' / 6 SELECTED';
      root.querySelector('[data-ms-form-count]').textContent = chosen.size + ' ' + (chosen.size === 1 ? config.one : config.unit);
      root.querySelector('[data-ms-form-plan]').textContent = names.join(' · ') || 'Please help me plan the scope.';
      root.querySelector('[data-ms-selection-input]').value = names.join('; ') || 'Please help me plan the scope.';
      root.querySelector('[data-ms-count-input]').value = String(chosen.size);
      root.querySelector('[data-ms-clear]').disabled = chosen.size === 0;
      root.querySelector('[data-ms-select-all]').disabled = chosen.size === labels.length;
    }
    function setProperty(next) {
      if (next !== 'home' && next !== 'business') return;
      property = next;
      propertyField.value = next === 'home' ? 'Home' : 'Business';
      feedback.textContent = 'Choose the priorities for your ' + (next === 'home' ? 'home.' : 'business.');
      update();
    }
    root.querySelectorAll('[data-ms-property]').forEach(button => button.addEventListener('click', () => setProperty(button.dataset.msProperty)));
    propertyField.addEventListener('change', () => setProperty(propertyField.value === 'Business' ? 'business' : 'home'));
    root.querySelectorAll('[data-ms-area], [data-ms-map-area]').forEach(button => button.addEventListener('click', () => {
      const i = Number(button.dataset.msArea ?? button.dataset.msMapArea);
      if (!Number.isInteger(i) || i < 0 || i >= config[property].length) return;
      selected[property].has(i) ? selected[property].delete(i) : selected[property].add(i);
      update();
      feedback.textContent = number(i) + ' — ' + config[property][i] + (selected[property].has(i) ? ' added to your plan.' : ' removed from your plan.');
    }));
    root.querySelector('[data-ms-select-all]').addEventListener('click', () => {
      selected[property] = new Set(config[property].map((_, i) => i));
      update();
      feedback.textContent = 'All priorities selected. You can adjust any item before requesting your quote.';
    });
    root.querySelector('[data-ms-clear]').addEventListener('click', () => {
      selected[property].clear();
      update();
      feedback.textContent = 'Selections cleared. Choose your priorities or ask our team to help with the plan.';
    });
    root.querySelectorAll('[data-ms-interest]').forEach(link => link.addEventListener('click', () => {
      root.querySelector('[data-ms-interest-input]').value = link.dataset.msInterest;
      root.querySelector('[data-ms-interest-text]').textContent = link.dataset.msInterest;
    }));
    update();
    if (form.dataset.mode !== 'text' || !dialog) return;
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const lines = ['MENKRAFTERS — ' + config.service + ' Quote Request', ''];
      for (const [key, value] of new FormData(form)) {
        const label = key.match(/^contact\[(.+)\]$/)?.[1];
        const text = String(value).trim();
        if (!label || !text || label === 'Service') continue;
        const display = {name:'Name',email:'Email',phone:'Phone',body:'Project details'}[label] || label;
        lines.push(display + ': ' + text);
      }
      const message = lines.join('\n');
      root.querySelector('[data-ms-message]').value = message;
      root.querySelector('[data-ms-copy-status]').textContent = '';
      const apple = /iPad|iPhone|iPod/.test(navigator.userAgent);
      root.querySelector('[data-ms-sms]').href = 'sms:+14692793043' + (apple ? '&' : '?') + 'body=' + encodeURIComponent(message);
      dialog.showModal();
    });
    root.querySelector('[data-ms-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    root.querySelector('[data-ms-copy]').addEventListener('click', async () => {
      const field = root.querySelector('[data-ms-message]');
      const status = root.querySelector('[data-ms-copy-status]');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(field.value);
        status.textContent = 'Copied. Paste this request into your message to MENKRAFTERS.';
      } catch {
        field.focus(); field.select();
        status.textContent = 'Your request is selected. Use Copy, then paste it into your message.';
      }
    });
  }
  const start = scope => {
    if (scope.matches?.('[data-ms-service]')) initialize(scope);
    scope.querySelectorAll('[data-ms-service]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), {once:true});
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
